module.exports = __webpack_public_path__ + "media/images/icons/twitter-c2ac23cf0a23ffcb1feccbbf4799ce98.png";